<template>
    <div v-if="showPaymentAndInvoiceStatus" class="payment-status-label text-caption" :class="statusColor">
        {{ text }}
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class PaymentStatusLabel extends Vue {
        @Prop({required: true}) status
        @Prop({default: false, type: Boolean}) cardGuarantee
        @Prop({default: false, type: Boolean}) noColor

        get text() {
            if (this.$conf.public.account.plainPaymentStatus || this.$conf.public.account.paymentScheduler) {
                return this.$t(
                    `plainPaymentStatus.${
                        !['OVERPAID', 'PAID', 'PARTIAL_PAID'].includes(this.status) ? 'NOT_PAID' : this.status
                    }`
                )
            } else {
                return this.$t(`paymentStatus.${this.cardGuarantee ? 'PAY_AT_HOTEL' : this.status}`)
            }
        }

        get statusColor() {
            if (this.noColor) return null
            if (this.$conf.public.account.plainPaymentStatus || this.$conf.public.account.paymentScheduler) {
                if (this.status === 'PAID' || this.status === 'OVERPAID') {
                    return 'text-success'
                } else if (this.status === 'PARTIAL_PAID') {
                    return 'text-warning'
                }
            } else {
                if (this.cardGuarantee) {
                    return 'text-info'
                } else if (['OVERPAID', 'PAID', 'BILL', 'PARTIAL_PAID'].includes(this.status)) {
                    return 'text-success'
                } else if (['NO_BILL', 'IN_TRANSIT', 'NO_FULLY_BILL', 'INVOICE_WAITING'].includes(this.status)) {
                    return 'text-warning'
                }
            }
            return 'text-error'
        }

        get showPaymentAndInvoiceStatus() {
            return authStore.showPaymentAndInvoiceStatus
        }
    }

    export default PaymentStatusLabel
</script>
